import { DEFAULT_DEBOUNCE_AND_THROTTLE_MS } from '~/lib/utils/constants';
import { getSlotFunction, normalizeRender } from '../../lib/utils/vue3compat/normalize_render.js?vue3';
import workItemByIidQuery from '../graphql/work_item_by_iid.query.graphql';
export default normalizeRender({
    name: 'WorkItemPrefetch',
    inject: {
        fullPath: {
            default: ''
        }
    },
    inheritAttrs: false,
    props: {
        workItemIid: {
            type: String,
            required: true
        },
        workItemFullPath: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            skipQuery: true
        };
    },
    apollo: {
        workItem: {
            query () {
                return workItemByIidQuery;
            },
            variables () {
                return {
                    fullPath: this.workItemFullPath || this.fullPath,
                    iid: this.workItemIid,
                    useWorkItemFeatures: true
                };
            },
            skip () {
                return !this.fullPath || this.skipQuery;
            },
            update (data) {
                return data.namespace?.workItem ?? {};
            }
        }
    },
    methods: {
        prefetchWorkItem () {
            this.prefetch = setTimeout(()=>{
                this.skipQuery = false;
            }, DEFAULT_DEBOUNCE_AND_THROTTLE_MS);
        },
        clearPrefetching () {
            if (this.prefetch) {
                clearTimeout(this.prefetch);
                this.prefetch = null;
            }
        }
    },
    render () {
        return getSlotFunction(this)({
            prefetchWorkItem: this.prefetchWorkItem,
            clearPrefetching: this.clearPrefetching
        });
    }
});
